import { makeAutoObservable } from "mobx";
import { DataTableStore } from "./DataTableStore";
import { onError } from "@/utils/onError";
import { FiltersStore } from "./FiltersStore";
import { SearchFilter } from "@/components/filters";
export class ServiceVehiclesStore {
    constructor(serviceVehicleService) {
        this.serviceVehicleService = serviceVehicleService;
        this.loading = false;
        this.initializeServiceVehicleFilters = () => {
            const filterItems = [
                // Search Filter
                {
                    id: "search-filter",
                    Cmp: SearchFilter,
                    props: {
                        name: "search",
                        label: "Поиск",
                        placeholder: "Поиск по номеру автомобиля, марке, модели...",
                        allowClear: true,
                        showSearchIcon: true,
                        onChange: (value) => this.filtersStore.updateFilter("search", value),
                    },
                    visible: true,
                    order: 4,
                },
            ];
            this.filtersStore.setFilterItems(filterItems);
        };
        this.dataTable = new DataTableStore({
            defaultFilters: { search: "" },
            dataLoader: {
                loadData: (params) => this.loadServiceVehicles(params),
            },
        });
        this.filtersStore = new FiltersStore();
        this.initializeServiceVehicleFilters();
        makeAutoObservable(this);
    }
    setLoading(loading) {
        this.loading = loading;
    }
    async loadServiceVehicles(params) {
        try {
            const result = await this.serviceVehicleService.getVehiclesWithParams({
                page: params.page,
                pageSize: params.pageSize,
                filters: params.filters,
                sorters: params.sorters,
            });
            return {
                data: result.data,
                total: result.total,
                page: result.page,
                pageSize: result.pageSize,
            };
        }
        catch (error) {
            throw error;
        }
    }
    async deleteVehicle(id) {
        this.setLoading(true);
        try {
            await this.serviceVehicleService.deleteVehicle(id);
            await this.dataTable.refresh();
        }
        catch (error) {
            onError(error, "Error deleting service vehicle");
        }
        finally {
            this.setLoading(false);
        }
    }
}
